// ENTITIES ##########################################################
// MODEL USED FOR TRANSITION APP<->API (TransitionalModelObject)
import { IArchivingTssLogEntityEvents } from '@core/interfaces/entity.interface';

export class ArchivingTssLogTMO {
	public id?: string = undefined;

	public businessDateFrom?: Date = undefined;

	public businessDateTo?: Date = undefined;

	public signatureCounterFrom?: number = undefined;

	public signatureCounterTo?: number = undefined;

	public transactionCounterFrom?: number = undefined;

	public transactionCounterTo?: number = undefined;

	public counters: ArchivingTssLogCounters = undefined;

	public filename?: string = undefined;

	public businessPremisesId?: string = undefined;

	public tssId?: string = undefined;

	public checksumAlgorithm?: string = undefined;

	public uncompressedChecksum?: string = undefined;

	public compressedChecksum?: string = undefined;

	public created?: Date = undefined;

	public originalUncompressedChecksum?: string = undefined;

	public originalCompressedChecksum?: string = undefined;

	public fccId?: string = undefined;

	public queryStartDate?: Date = undefined;

	public queryEndDate?: Date = undefined;

}

export class ArchivingTssLogCountersTMO {
	public audit?: ArchivingTssLogCounterRange[] = undefined;

	public signature?: ArchivingTssLogCounterRange[] = undefined;

	public transaction?: ArchivingTssLogCounterRange[] = undefined;
}

export class ArchivingTssLogCounterRangeTMO {
	public from?: number = undefined;

	public to?: number = undefined;
}

// MODEL USED IN APPLICATION (with additional properties)
export class ArchivingTssLog extends ArchivingTssLogTMO {
	public etag?: string = undefined;

	public ui?: IArchivingTssLogEntityEvents = {
		businessDateTitle: undefined
	};
}

export class ArchivingTssLogCounters extends ArchivingTssLogCountersTMO {
	public signaturesSum?: number = undefined;

	public transactionsSum?: number = undefined;
}

export class ArchivingTssLogCounterRange extends ArchivingTssLogCounterRangeTMO {
}

// INTERFACES ########################################################
// API interfaces ****************************************************

// UI interfaces *****************************************************


// ENUMS #############################################################
// API enums *********************************************************

// UI enums *********************************************************
